/**
 * Initial-on-open behaviour of the recap product-dropdown stock checkbox.
 * Backed by the `recapStockFilterMode` feature flag (STK-1049).
 * - `persist`   — open with the last-left state (today's behaviour)
 * - `checked`   — always open checked
 * - `unchecked` — always open unchecked
 */
export type StockFilterMode = "persist" | "checked" | "unchecked";

/**
 * Returns the `filterInStock` value the dropdown should open with.
 * `checked`/`unchecked` force the value; `persist` (and any unknown mode)
 * uses the persisted localStorage value.
 */
export function resolveInitialStockFilter(
  mode: StockFilterMode,
  persistedValue: boolean,
): boolean {
  if (mode === "checked") return true;
  if (mode === "unchecked") return false;
  return persistedValue;
}
